import { For, Show } from "solid-js";
import { createQuery } from "@tanstack/solid-query";

// GET /api/super-admin/cli-clients renvoie { ok, hosts } depuis host_modules.
interface CliHost {
  host_id: string;
  hostname: string | null;
  platform: string | null;
  version: string | null;
  online: boolean | null;
  last_seen: string;
  tenant_id: string | null;
  client_id: string | null;
}

async function jget<T>(url: string): Promise<T> {
  const r = await fetch(url, { credentials: "include" });
  if (!r.ok) throw new Error(`${url} → ${r.status}`);
  return r.json() as Promise<T>;
}

export function SuperAdminCliClientsPage() {
  const q = createQuery<{ ok: boolean; hosts: CliHost[] }>(() => ({
    queryKey: ["super-admin-cli-clients"],
    queryFn: () => jget<{ ok: boolean; hosts: CliHost[] }>("/api/super-admin/cli-clients"),
    refetchInterval: 10_000,
  }));

  return (
    <div class="plugins-console" style={{ overflow: "auto" }}>
      <div class="plugins-console-header">
        <span class="plugins-console-title">
          CLI Clients
          <span class="plugins-console-sub">agents CLI / outils externes connectés</span>
        </span>
      </div>

      <Show when={q.error}>
        <div class="bug-report-message" data-kind="err" style={{ "margin-bottom": "10px" }}>
          {q.error instanceof Error ? q.error.message : String(q.error)}
        </div>
      </Show>

      <div class="rmm-table-wrap">
        <table class="rmm-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Version</th>
              <th>OS</th>
              <th>En ligne</th>
              <th>Dernière activité</th>
            </tr>
          </thead>
          <tbody>
            <Show
              when={!q.isLoading}
              fallback={
                <tr>
                  <td colSpan={5}>Chargement…</td>
                </tr>
              }
            >
              <For each={q.data?.hosts || []}>
                {(c) => (
                  <tr>
                    <td style={{ "font-weight": "500" }}>{c.hostname || "—"}</td>
                    <td style={{ "font-size": "11px" }}>{c.version || "—"}</td>
                    <td style={{ "font-size": "11px" }}>{c.platform || "—"}</td>
                    <td>
                      <span
                        style={{
                          "font-size": "10px",
                          "text-transform": "uppercase",
                          padding: "1px 6px",
                          "border-radius": "4px",
                          background: c.online ? "rgba(74,222,128,0.12)" : "rgba(148,163,184,0.12)",
                          color: c.online ? "var(--ok, #4ade80)" : "var(--text-4)",
                        }}
                      >
                        {c.online ? "online" : "offline"}
                      </span>
                    </td>
                    <td style={{ "font-size": "11px", color: "var(--text-4)" }}>
                      {c.last_seen ? new Date(c.last_seen).toLocaleString() : "—"}
                    </td>
                  </tr>
                )}
              </For>
              <Show when={(q.data?.hosts || []).length === 0}>
                <tr>
                  <td colSpan={5} style={{ color: "var(--text-4)", "text-align": "center" }}>
                    Aucun client CLI.
                  </td>
                </tr>
              </Show>
            </Show>
          </tbody>
        </table>
      </div>
    </div>
  );
}
